import 'core-js/stable'
import dayjs from 'dayjs'
import { createRoot } from 'react-dom/client'
import { initHotjar, initSentry } from './utils/trackingUtils'
import 'regenerator-runtime/runtime'
import './styles/main.sass'

import 'dayjs/locale/en-gb'
import 'dayjs/locale/sk'

// import { init as initApm } from '@elastic/apm-rum'

import App from './App'
import ErrorBoundary from './ErrorBoundary'
import { register } from './registerServiceWorker'

dayjs.locale('en-gb')

initSentry()
initHotjar()

register()

const root = createRoot(document.body.querySelector('#root') as HTMLElement)
root.render(
	<ErrorBoundary>
		<App />
	</ErrorBoundary>
)
